import classNames from 'classnames'
import React from 'react'

import img from '../../../assets/images/last-flat-card.png'
import { NewIconArrow } from '../../icons/NewIconArrow'
import { BuildingType } from '../../NewCards/NewCards.types'
import styles from './LastFlatCard.module.scss'

function LastFlatCard(props: {
  link?: string
  state?: string
  type?: BuildingType
}) {
  const {
    link = 'https://www.pik.ru/search?projects=1&utm_source=rbc&utm_medium=display&utm_content=allflats',
    state,
    type,
  } = props

  const wrapperClasses = classNames(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles.wrapper,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    state && styles[`state-${state}`]
  )

  return (
    <a href={link} target='_blank' className={wrapperClasses}>
      <img src={img} alt='образец планировки квартиры' />
      <span className={styles.text}>
        {type === 'flat' ? (
          <>
            Ещё больше квартир на <u>pik.ru</u>
          </>
        ) : (
          <>
            Ещё больше помещений на <u>pik.ru</u>
          </>
        )}
      </span>
      <div className={styles.btn}>
        {state === 'row' ? (
          <NewIconArrow />
        ) : (
          <span className='btn btn--small btn--white no-hover'>Подробнее</span>
        )}
      </div>
    </a>
  )
}

export default LastFlatCard
